import { render, staticRenderFns } from "./RetailerStatement.vue?vue&type=template&id=a4d7f544"
import script from "./RetailerStatement.vue?vue&type=script&lang=js"
export * from "./RetailerStatement.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports